import { MAKE_COST } from '../lib/shop';

// What a student still needs before they can send a game to their teacher,
// shown above the Send button so a greyed-out button is never a mystery.
export default function SendChecklist({ named, problem, beaten, balance, verb }: { named: boolean; problem: string; beaten: boolean; balance: number; verb: 'beat' | 'finish' }) {
  const items = [
    { ok: named, text: 'Give it a name (at the top)' },
    { ok: !problem, text: problem || 'It has everything it needs' },
    { ok: beaten, text: verb === 'beat' ? 'Beat your own level: press ▶ Play it and reach the flag' : 'Finish your own course: press 🏎️ Drive it and cross the finish' },
    { ok: balance >= MAKE_COST, text: balance >= MAKE_COST ? `🪙 ${MAKE_COST} to send it (you have 🪙 ${balance})` : `🪙 ${MAKE_COST} to send it: you have 🪙 ${balance}, so you need ${MAKE_COST - balance} more. Earn sand dollars by doing your assignments!` },
  ];
  const all = items.every(i => i.ok);
  return (
    <div className="send-check" aria-label="Before you can send it">
      <strong className="small">{all ? '✅ Ready to send!' : 'To send it to your teacher:'}</strong>
      {!all && (
        <ul>
          {items.map((i, k) => <li key={k} className={i.ok ? 'ok' : 'todo'}>{i.ok ? '✅' : '⬜'} {i.text}</li>)}
        </ul>
      )}
    </div>
  );
}
